module.exports = __webpack_public_path__ + "img/35.255bf613.jpg";